import React from "react"
import ReactMarkdown from 'react-markdown';


const HotspotText = ({title, text}) => {
    return (
        <div className="text-container">
            <h1>{title}</h1>
            <ReactMarkdown className="markdown" source={text}/>
        </div>
    )
}

export default HotspotText;